<template>
<article class="me-nu" v-if="props.node.resourceType === 'MENU'">
  <section :class="{'me-item': true, 'me-sel': computeSelected }">
    <p :class="{ 'exp-and': true, 'exp-ed': computeExpanded, 'em-pty': !computeHasChild }" @click="handleToggleExpand">▶</p>

    <p class="check-box" :class="computeBoxState" @click="handleNodeClick">
      {{computeBoxState === 'che-ked' ? '✓' : computeBoxState === 'indeterminate' ? '−' : ''}}
    </p>

    <!-- 菜单 名称、类型 {{ props.node.resourceType }} -->
    <div class="me-con">
      <p>{{props.node.resourceName}}</p> <span>{{$t('菜单权限')}}</span>
    </div>
  </section>
  <!-- 子菜单 -->
  <section class="me-child" v-if="computeHasChild && computeExpanded">
    <PermissionNode v-for="c in computeMenus" :key="c.resourceId" :node="c" :selectedPermissions="props.selectedPermissions" :expandedNodes="props.expandedNodes" @emitTree="emit('emitTree', $event, arguments[1])" @emitExpand="emit('emitExpand', $event)"></PermissionNode>

    <ul class="me-page" v-if="computePages.length > 0 || computeButs.length > 0">
      <!-- 页面 -->
      <li :class="{ 'sel-ect': isPageSelected(p.resourceId) }" v-for="p in computePages" :key="p.resourceId">

        <div class="p-header" @click="emit('emitTree', p.resourceId, p)">
          <div :class="{ 'pa-check': true, 'p-check': isPageSelected(p.resourceId) }">
            {{isPageSelected(p.resourceId) ? '✓' : ''}}
          </div>
          <!-- {{ p.resourceName }} -->
          <p>{{$t('全部权限')}}</p>
<!--          <span>{{ p.resourceType }}</span>-->
        </div>

        <div class="bt-con" v-if="computeButs.length > 0">
          <p :class="{ 'sel-ect': isButtonSelected(i.resourceId) }" v-for="i in computeButs" :key="i.resourceId" @click="emit('emitTree', i.resourceId, i)">
            {{i.resourceName}}
          </p>
        </div>
      </li>
      <!-- 仅按钮 -->
      <li v-if="computePages.length === 0 && computeButs.length > 0">
        <div class="p-header">
          <p>{{$t('操作权限')}}</p><span>buttons</span>
        </div>

        <div class="bt-con">
          <p :class="{'sel-ect': isButtonSelected(i.resourceId) }" v-for="i in computeButs" :key="i.resourceId" @click="emit('emitTree', i.resourceId, i)">
            {{i.resourceName}}
          </p>
        </div>
      </li>
    </ul>
  </section>
</article>
</template>

<script setup="true" name="PermissionNode">
import {computed, onMounted} from "vue"

const props = defineProps({
  node: {
    type: Object,
    default: () => {
      return {
        checked: false,
        hotelVid: '',
        resourceId: '',
        resourcePid: '',
        resourceName: '',
        resourceType: '',
        children: []
      }
    }
  },
  selectedPermissions: {
    type: Array,
    required: true
  },
  expandedNodes: {
    type: Array,
    required: true
  },
})

const emit = defineEmits(['emitTree', 'emitExpand'])

const computeBoxState = computed(() => getCheckboxState(props.node) )
const computeHasChild = computed(() => props.node?.children?.length > 0)
const computeExpanded = computed(() => props.expandedNodes.includes(props.node?.resourceId) )
const computeSelected = computed(() => props.selectedPermissions.includes(props.node?.resourceId) )
const computePages = computed(() => props.node?.children?.filter(f => f.resourceType === 'PAGE') || [])
const computeButs = computed(() => props.node?.children?.filter(f => f.resourceType === 'BTN') || [])
const computeMenus = computed(() => props.node?.children?.filter(f => f.resourceType === 'MENU') || [])

onMounted(() => {

})
/**
 *@Description 箭头 事件 监听.
 *@Return
**/
const handleToggleExpand = () => {
  emit('emitExpand', props.node?.resourceId)
}
/**
 *@Description 选择 展示 类名 .
 *@Return
**/
const getCheckboxState = (node) => {
  const isSelected = props.selectedPermissions.includes(node.resourceId)
  if (isSelected) return 'che-ked'

  if (node.children) {
    const selectedChildren = node.children.filter(child =>
        props.selectedPermissions.includes(child.resourceId) || getCheckboxState(child) !== 'unchecked'
    )
    // 修改：只要有子菜单被选中，就返回选中状态，并确保主菜单也被添加到已选择列表
    if (selectedChildren.length > 0) {
      // 确保主菜单权限也被添加到selectedPermissions中
      if (!props.selectedPermissions.includes(node.resourceId)) {
        props.selectedPermissions.push(node.resourceId)
      }
      return 'che-ked'
    }
  }

  return 'unchecked'
}
/**
 *@Description 选择 展示 类名 .
 *@Return
**/
const handleNodeClick = () => {
  emit('emitTree', props.node?.resourceId, props.node)
}

const isPageSelected = (pId) => props.selectedPermissions.includes(pId)
const isButtonSelected = (bId) => {

  if (props.selectedPermissions.includes(bId)) {
    return true
  }

  // 检查同级是否有页面被选中（隐式选中状态）
  if (props.node?.children) {
    // 如果当前节点有children，说明按钮和页面是当前节点的子节点
    const siblingPages = props.node.children.filter(child => child.resourceType === 'PAGE')
    return siblingPages.some(page => props.selectedPermissions.includes(page.resourceId))
  }

  return false
}
</script>

<style lang="scss" scoped>
.me-nu {
  margin-bottom: 8px;
}

.me-item {
  display: flex;
  padding: 8px 12px;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  background: #fff;
  margin-bottom: 6px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    background: #f8fafc;
    border-color: #3b82f6;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
  }
}
.me-sel {
  border-color: #3b82f6;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
}
.exp-and {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  border-radius: 3px;
  font-size: 12px;
  color: #6b7280;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    background: #f3f4f6;
    color: #374151;
    transform: scale(1.1);
  }
}
.exp-ed {
  transform: rotate(90deg);
}
.em-pty {
  visibility: hidden;
}
// check 框
.check-box {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  font-size: 12px;
  border: 1.5px solid #d1d5db;
  &:hover {
    border-color: #3b82f6;
    transform: scale(1.05);
  }
}
.che-ked {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}
.indeterminate {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #fff;
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
}
// 菜单 名称
.me-con {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
  p {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    flex: 1;
  }
  span {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #6b7280;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
  }
}
// 子菜单容器
.me-child {
  margin-top: 8px;
  margin-left: 32px;
  transition: all 0.2s ease;
}
// 子 菜单 页面
.me-page {
  display: grid;
  gap: 8px;
  margin-top: 8px;
  grid-template-columns: repeat(auto-fill, minmax(80%, 1fr));
  li {
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e7eb;
    &:hover {
      border-color: #16a34a;
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(22, 163, 74, 0.1);
    }
  }
  .sel-ect {
    border-color: #16a34a;
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    box-shadow: 0 2px 8px rgba(22, 163, 74, 0.2);
  }
}
.p-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  cursor: pointer;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  p {
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    flex: 1;
    line-height: 1.4;
  }
  span {
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 9px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    background: #f0f9ff;
    color: #0369a1;
    border: 1px solid #e0f2fe;
  }
}
.sel-ect {
  .p-header {
    background: #f0fdf4;
  }
}
// 页面 选择 框
.pa-check {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  font-size: 10px;
  border-radius: 3px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1.5px solid #d1d5db;
}
.p-check {
  color: #fff;
  background: #16a34a;
  border-color: #16a34a;
  box-shadow: 0 2px 4px rgba(22, 163, 74, 0.3);
}
// 按钮 容器
.bt-con {
  padding: 8px 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-right: -8px;
  p {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
    background: #fff;
    font-size: 12px;
    font-weight: 500;
    color: #374151;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    &:hover {
      color: #dc2626;
      border-color: #dc2626;
      transform: translateY(-1px);
      background: #fef2f2;
      box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1);
    }
  }
  p.sel-ect {
    color: #fff;
    border-color: #dc2626;
    box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);
    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  }
}
</style>
